var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"share-animated-button",style:({'color': _vm.color, 'borderColor': _vm.borderColor}),on:{"click":_vm.openShare}},[_c(_vm.icon,{tag:"component"}),_c('div',{class:{'share-animated-button-text': !_vm.fullView, 'share-animated-button-text-full-view': _vm.fullView}},[_vm._v("Share")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }